var map = {
	"./electoral-college/diverging-votes/desktop.svg": "61ef",
	"./electoral-college/diverging-votes/mobile.svg": "6652",
	"./electoral-college/diverging-votes/tablet.svg": "389a",
	"./electoral-college/icons/allotment-of-electors-desktop.svg": "34cf",
	"./electoral-college/icons/allotment-of-electors.svg": "0c4b",
	"./electoral-college/icons/election-day-desktop.svg": "3dd8",
	"./electoral-college/icons/election-day.svg": "c15f",
	"./electoral-college/icons/electoral-college-convenes-desktop.svg": "cf23",
	"./electoral-college/icons/electoral-college-convenes.svg": "3369",
	"./electoral-college/icons/nomination-of-electors-desktop.svg": "37e1",
	"./electoral-college/icons/nomination-of-electors.svg": "31e2",
	"./electoral-college/icons/winner-takes-all-desktop.svg": "82ba",
	"./electoral-college/icons/winner-takes-all.svg": "3ff8",
	"./electoral-college/map/bg-mobile.jpg": "7350",
	"./electoral-college/map/bg.jpg": "23f2",
	"./electoral-college/map/desktop.svg": "0a2d",
	"./electoral-college/map/mobile.svg": "8a2e",
	"./electoral-college/map/tablet.svg": "1287",
	"./template/image-background-header-desktop.jpg": "5c5b",
	"./template/image-background-header.jpg": "32e0",
	"./template/sample-image-desktop.png": "3100",
	"./template/sample-image.png": "da96",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8453";